module.exports = __webpack_public_path__ + "img/PR9.1651bf37.png";